import React, { ReactNode } from 'react';
import { Button } from 'antd';
import styles from './style.module.scss';

const MainButton: React.FC<{
  text: string | ReactNode;
  subButton?: boolean;
  onClick?: () => void;
  htmlType?: 'button' | 'submit' | 'reset';
  disable?: boolean;
}> = ({ text, subButton, onClick, htmlType, disable }) => (
  <Button
    type="primary"
    className={subButton ? styles.drakButton : styles.mainButton}
    onClick={onClick}
    htmlType={htmlType ?? 'button'}
    disabled={disable}
  >
    {text}
  </Button>
);

export default MainButton;
